import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, retry } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Planes } from '../../Models/planes';
import { Lead } from '../../components/loader-moto/loader-moto.component';
import { getSessionId } from '../../helpers/storageUtils';
import { TokenService } from '../../shared/services/token.service';
import { UtilsService } from '../utils.service';

@Injectable({
  providedIn: 'root',
})
export class PlanesService {
  baseUrl = environment.URL_API_PLANES;
  _body = {};
  tokenService = inject(TokenService);
  SESSION_ID = getSessionId().toString();
  private http = inject(HttpClient);
  private utils = inject(UtilsService);

  constructor() {}

  public getPlanes(sessionId: string, leadId: Lead): Observable<Planes | null> {
    const data = JSON.stringify(leadId);
    const urlWithTimestamp = `${this.baseUrl}`;
    const headers = this.utils.getHeaders(this.SESSION_ID);

    const body = JSON.parse(data);

    return this.http.post<Planes>(urlWithTimestamp, body, { headers }).pipe(
      retry(2),
      catchError((error) => {
        console.error(`Failed request for leadId ${leadId}:`, error);
        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
      }),
    );
  }
}
